import { TextInput } from '../fields'
import UpiField from '../UpiField'

export default function StepBank() {
  return (
    <div className="step-panel space-y-4">
      <TextInput
        name="ac_holder_name"
        label="Account Holder Name"
        placeholder="As per bank records"
        rules={{ required: 'Account holder name is required.' }}
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <TextInput
          name="bank_name"
          label="Bank Name"
          placeholder="State Bank of India"
          rules={{ required: 'Bank name is required.' }}
        />
        <TextInput
          name="branch_name"
          label="Branch Name"
          placeholder="Connaught Place"
          rules={{ required: 'Branch name is required.' }}
        />
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <TextInput
          name="ac_number"
          label="Account Number"
          placeholder="0000 0000 0000"
          maxLength={18}
          digitsOnly
          rules={{
            required: 'Account number is required.',
            pattern: { value: /^[0-9]{9,18}$/, message: 'Enter a valid account number (9–18 digits).' },
          }}
        />
        <TextInput
          name="ifsc_code"
          label="IFSC Code"
          placeholder="SBIN0001234"
          maxLength={11}
          style={{ textTransform: 'uppercase' }}
          rules={{
            required: 'IFSC code is required.',
            pattern: { value: /^[A-Za-z]{4}0[A-Za-z0-9]{6}$/, message: 'Enter a valid IFSC, e.g. SBIN0001234.' },
          }}
        />
      </div>
      <UpiField />
    </div>
  )
}
